export default __webpack_public_path__ + "static/2142-d738dff42896bda3110b0b231b77d61b.gif";